import { useGetOrganizationQuery } from '@/store/api/organization';

export function useOrganizationLogoUrl() {
  const { data } = useGetOrganizationQuery();
  if (!data?.logoUrl) return null;
  const trimmed = data.logoUrl.trim();
  return trimmed === '' ? null : trimmed;
}
